import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/alt-text */
import { mergeClasses } from '@/utils/style';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useRef } from 'react';
import { useCardScroll } from './useCardScroll';
import { Card, StackCardsProps } from './types';
import { Headline, Text } from '@/components/typography';
export function CardImageOnLeft(props) {
  const $ = _c(40);
  const {
    totalCards,
    index,
    setActiveTab,
    description,
    footer,
    images,
    title
  } = props;
  const ref = useRef(null);
  let t0;
  if ($[0] !== index || $[1] !== setActiveTab || $[2] !== totalCards) {
    t0 = {
      totalCards,
      index,
      setActiveTab,
      ref
    };
    $[0] = index;
    $[1] = setActiveTab;
    $[2] = totalCards;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    isMobile,
    transform
  } = useCardScroll(t0);
  const t1 = index === 0 && "mb-[32px] lg:mb-[64px]";
  const t2 = index === 1 && "top-[88px] mb-[24px] lg:top-[174px] lg:mb-[48px]";
  const t3 = index === 2 && "top-[96px] mb-[16px] lg:top-[198px] lg:mb-[32px]";
  const t4 = index === 3 && "top-[104px] mb-[8px] lg:top-[222px] lg:mb-[16px]";
  const t5 = index === 4 && "top-[112px] mb-0 lg:top-[246px]";
  let t6;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = mergeClasses("shadow-floating sticky top-[80px] origin-[50%_0%] rounded-2xl bg-white", "lg:top-[150px] lg:rounded-[40px]", "h-[468px] w-full lg:h-[520px] lg:max-w-full", "p-4 pb-6 lg:p-8", t1, t2, t3, t4, t5);
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== transform) {
    t7 = {
      scaleX: transform,
      scaleY: transform
    };
    $[10] = transform;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      scaleX: 1,
      scaleY: 1
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = images.variant === "appMockup" ? "top-2 max-w-[14rem] lg:top-auto lg:bottom-0 lg:max-w-[75%]" : "top-1/2 max-w-[60%] -translate-y-1/2 lg:max-w-full";
  let t10;
  if ($[13] !== t9) {
    t10 = mergeClasses("absolute left-1/2 z-10 -translate-x-1/2", t9);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = isMobile ? images.mobile : images.desktop;
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <Image className={t10} {...t11} width={383} height={734} sizes="100vw" />;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== images.variant) {
    t13 = images.variant === "appMockup" && <div className="absolute top-1/2 left-1/2 h-[44rem] w-[44rem] -translate-x-1/2 rounded-full bg-blue-200 sm:h-[65rem] sm:w-[65rem] md:top-1/3 lg:top-1/2 lg:h-[70rem] lg:w-[70rem]" />;
    $[18] = images.variant;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <div className="relative h-40 w-full shrink-0 overflow-hidden rounded-xl bg-blue-100 sm:h-[16.5rem] lg:h-full lg:w-[480px] lg:rounded-4xl">{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== title) {
    t15 = <Headline as="h3" variant="h4" className="text-gray-900" data-analytics-param="cardContent">{title}</Headline>;
    $[23] = title;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== description) {
    t16 = description && <Text as="div" variant="p2" className="mt-2 lg:mt-4">{description}</Text>;
    $[25] = description;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== footer) {
    t17 = footer && <div className="mx-auto mt-6 max-w-72 md:mt-8 lg:mx-0 lg:mt-10">{footer}</div>;
    $[27] = footer;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15 || $[30] !== t16 || $[31] !== t17) {
    t18 = <div className="xs:px-4 w-full md:p-0">{t15}{t16}{t17}</div>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t14 || $[34] !== t18) {
    t19 = <div className="flex h-full flex-col items-center gap-6 overflow-hidden md:gap-8 lg:flex-row lg:gap-20 lg:rounded-[1.25rem]">{t14}{t18}</div>;
    $[33] = t14;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t19 || $[37] !== t6 || $[38] !== t7) {
    t20 = <motion.article ref={ref} className={t6} style={t7} initial={t8}>{t19}</motion.article>;
    $[36] = t19;
    $[37] = t6;
    $[38] = t7;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
}